import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';

export const initialValuesRegion = {
  name: '',
  code: '',
  orders: {},
  page: 0,
  rowsPerPage: 10,
};

const PageRegionListInitializer = (): ReactElement => {
  return (
    <FilterTableProvider initialValues={initialValuesRegion}>
      <Outlet />
    </FilterTableProvider>
  );
};

PageRegionListInitializer.displayName = 'Page region List initializer component';

export default PageRegionListInitializer;
